import React from 'react';
import { PostLoginSkeleton } from '../../pages/login/post-login';

interface LoginSafeSuspenseProps {
    children: React.ReactNode;
}

export const LoginSafeSuspense = ({ children }: LoginSafeSuspenseProps) => (
    <React.Suspense fallback={<PostLoginSkeleton />}>
        {children}
    </React.Suspense>
);